<template>
  <v-container id="data-tables" tag="section" fluid>
    <base-material-card color="primary" icon="mdi-crosshairs-question" inline class="ml-0 px-5 py-3">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }}
        </div>
      </template>

      <v-btn
        id="predicao-baixas-create"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="adicionarPredicao()"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        NOVA PREDIÇÃO
      </v-btn>

      <v-text-field
        id="predicao-baixas-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-predicoes ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />

      <v-divider class="mt-10" />

      <v-data-table
        id="predicao-baixas-data-table"
        class="predicoes-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhuma predição de baixas disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        mobile-breakpoint="800"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.titulo`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.titulo }}
              </div>
            </template>
            <span>{{ item.titulo }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.cenario_vinculado`]="{ item }">
          {{ item.cenario_vinculado ? item.cenario_vinculado.titulo : '-' }}
        </template>
        <template v-slot:[`item.precisao`]="{ item }">
          {{ item.precisao == 'RAPIDO' ? 'RÁPIDO' : item.precisao }}
        </template>
        <template v-slot:[`item.base`]="{ item }">
          {{ item.base }}
        </template>
        <template v-slot:[`item.executed`]="{ item }">
          {{ item.executed }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="predicao-baixas-visualizar"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            color="gray"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            @click="resultado(item.id)"
          >
            <v-icon small>mdi-file-eye-outline</v-icon>
          </v-btn>
          <v-menu v-if="canRunItem(item) || canDeleteItem(item)" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-predicao"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarPredicao(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.titulo)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>

              <v-list-item
                @click="
                  ((dialogCreationLog = true),
                  (dialogCreationLogData = {
                    username: item.usuario,
                    created: item.created
                  }))
                "
              >
                <v-list-item-title>
                  <v-icon small>mdi-table-search</v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="downloadLogs(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-file-download-outline</v-icon>
                  Downlad Logs
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletePredicao(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Predição #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar a predição
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
  </v-container>
</template>

<script>
  import PredicoesService from '@/services/PredicoesBaixasService.js';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';

  export default {
    name: 'PredicoesBaixasDataTables',

    components: {
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      DialogDelete: () => import('@/components/general/DialogDelete'),
      DialogCreationLog: () => import('@/components/general/DialogCreationLog')
    },

    mixins: [powerupsActionsMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      title: {
        type: String,
        default: 'Tabela'
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    emits: ['switchProcessamentosExpirados', 'recharge'],

    data: () => ({
      search: undefined,
      dialogDelete: false,
      dialogDeleteData: { id: undefined, titulo: undefined },
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Titulo',
          value: 'titulo'
        },
        {
          text: 'Precisão',
          value: 'precisao'
        },
        {
          text: 'Base',
          value: 'base'
        },
        {
          text: 'Cenário Vinculado',
          value: 'cenario_vinculado'
        },
        {
          text: 'Data Base',
          value: 'data_base'
        },
        {
          text: 'Executado',
          value: 'executed'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ]
    }),

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    methods: {
      downloadLogs(id) {
        const empresa = this.$store.getters.getEmpresa;
        PredicoesService.downloadLogs({ id, empresa })
          .then((res) => {
            this.$toast.success('Preparando seu arquivo de logs para download.', '', { position: 'topRight' });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `logs-predicoes-de-baixas-${id}.log`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Falha ao baixar arquivo resultado :: Arquivo não encontrado.', '', { position: 'topRight' });
          });
      },

      resultado(id) {
        this.$router.push('resultado/' + id);
      },

      deletePredicao(id) {
        PredicoesService.deletePredicao(id)
          .then(() => {
            this.$emit('recharge');
            this.$toast.success('Predição excluida com sucesso.', '', {
              position: 'topRight'
            });
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Erro ao excluir predição.', '', {
              position: 'topRight'
            });
          });

        this.dialogDelete = false;
      },

      editarRelatorio(id) {
        this.$router.push('edit/' + id);
      },

      adicionarPredicao() {
        this.$router.push('edit');
      },

      executarPredicao(id) {
        PredicoesService.executarPredicao(id)
          .then(() => {
            this.$emit('recharge');
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Erro ao executar predição.', '', {
              position: 'topRight'
            });
          });
      },

      openDialogDelete(id, titulo) {
        this.dialogDeleteData = { id: id, titulo: titulo };
        this.dialogDelete = true;
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .predicoes-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .predicoes-table table tr td:nth-child(7),
    .predicoes-table table tr td:nth-child(8) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-predicoes {
      width: 186.95px !important;
    }
  }

  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>
